<template>
    <div class="white" style="border-bottom: 20px solid #eee!important; padding: 20px;">
        <div style="display: flex; justify-content: center; align-items: center;">
            <div style="line-height: 1; text-align: left; width: 100px; padding-right: 20px; text-align: center; flex-shrink: 0; border-right: 0px solid #eee;">
                <template v-if="item.svg">
                    <img :src="item.svg" style="width: 60px;" />
                </template>
                <template v-else-if="item.icon">
                    <component :is="item.icon" style="width: 70px;" />
                </template>
                <SvgEmail v-else style="width: 70px;" />
                <br/>
                <template v-if="subscribed">
                    <div class="grey--text text--darken-3" style="font-size: 11px">
                        <b style="font-weight: 600">
                            {{ realPrice }}
                        </b>
                        <span v-if="item.price !== 'FREE'">
                            <span v-if="!item.period || item.period === 'monthly'">
                                &nbsp;{{ $t('payment.per_month') }}
                            </span>
                            <span v-else-if="item.period && item.period === 'annual'">
                                &nbsp;{{ $t('payment.per_year') }}
                            </span>
                        </span>
                    </div>
                </template>
                <template v-if="!subscribed">
                    <div class="black--text" style="font-size: 15px">
                        <b style="font-weight: 600">
                            {{ realPrice }}</b>
                            <br />
                            <small v-if="item.price !== 'FREE'" class="grey--text text--darken-3">
                                <span v-if="!item.period || item.period === 'monthly'">
                                    &nbsp;{{ $t('payment.per_month') }}
                                </span>
                                <span v-else-if="item.period && item.period === 'annual'">
                                    &nbsp;{{ $t('payment.per_year') }}
                                </span>
                            </small>
                        </div>
                </template>
            </div>
            <div style="text-align: left; flex-grow: 1; padding-left: 20px; border-left: 2px solid #eee;">
                <h2 class="f16 blue--text text--accent-3">{{ item.title }}</h2>
                <span style="font-size: 12px; margin-top: 5px; display: block; line-height: 1.3;">{{ item.desc }}</span>
                <div v-if="subscribed" style="font-size: 11px; margin: 10px 0;">

                    <v-btn dark class="green" style="font-size: 15px; box-shadow: none; display: inline-flex; margin: 0 0 10px 0;border: 2px solid #fff!important; height: 42px; padding: 8px 24px 8px 24px!important; border-radius: 40px; background: #2979ff;">
                        <div style="color: #fff!important; text-align: left; line-height: 1.3;">
                            {{ $t('subscriptions.subscribed') }}
                        </div>
                    </v-btn>
                    <div @click="$emit('unsubscribe')" style="text-decoration: underline; color: #555!important; text-align: left; line-height: 1.3;" v-if="true">
                        {{ $t('payment.cancel_subscription_btn') }}
                    </div>
                    <div style="color: #555!important; text-align: left; line-height: 1.3;" v-else>
                        {{ $t('payment.cancel_subscription_in_progress') }}
                    </div>
                </div>
                <div v-if="!subscribed" style="text-align: left;">
                    <v-btn dark :loading="item.processing" @click="$emit('subscribe')" style="font-size: 15px; box-shadow: 3px 3px 10px rgba(0,0,0,.2); display: inline-flex; margin: 10px 0;border: 2px solid #fff!important; height: 42px; padding: 8px 24px 8px 24px!important; border-radius: 40px; background: #2979ff;">
                        <div style="color: #fff!important; text-transform: none!important; text-align: left; line-height: 1.3;text-overflow: ellipsis; max-width: 50vw; overflow: hidden">
                            {{ $t('payment.subscribe_now') }}
                        </div>
                    </v-btn>
                    <br>
                    <small v-if="item.price!=='FREE'" class="blue--text text--darken-2 bold--text" @click="$emit('restorePurchase')">{{ $t('payment.restore_subscription') }}</small>
                </div>
            </div>
        </div>

        <div v-if="!subscribed" style="text-align: right; margin-top: 8px;">

        </div>

    </div>
</template>
<script>
    import SvgEmail from "../svg/email";
    import SvgCloud from "../svg/cloud";
    import SvgProtocol from "../svg/protocol";
    export default {
        components: {
            SvgEmail,
            SvgCloud,
            SvgProtocol
        },
        props: {
            item: {
                type: Object,
            },
        },
        data() {
            return({
            });
        },
        computed: {
            subscribed() {
                if (this.item.subscribed === true) return true;

                if (typeof this.item.show_subscribed !== 'undefined') {
                    for (let i = 0; i <this.item.show_subscribed.length; i++) {
                        const sku = this.item.show_subscribed[i];
                        if (typeof window.IAP.products[sku] !== 'undefined' && window.IAP.products[sku].subscribed === true) return true;
                    }
                }
                return false;
            },
            realPrice() {
                try {
                    let priceString = this.item.price;

                    const currenciesWithDollarSymbol = [
                        'ARS', 'AUD', 'BSD', 'BBD', 'BMD', 'BND',
                        'CAD', 'KYD', 'CLP', 'COP', 'XCD', 'SVC',
                        'FJD', 'GYD', 'HKD', 'LRD', 'MXN', 'NAD',
                        'NZD', 'SYP', 'TVD', 'USD',
                    ];
                    const currenciesWithPoundSymbol = [
                        'EGP', 'FKP', 'GIP', 'GGP', 'IMP', 'JEP',
                        'LBP', 'SHP', 'SGD', 'SBD', 'SRD', 'GBP',
                    ];

                    // Show currency code on certain currencies for disambiguation
                    if([
                        ...currenciesWithDollarSymbol,
                        ...currenciesWithPoundSymbol,
                    ].includes(this.item.currencyCode)) {
                        const currencyCode = this.item.currencyCode;
                        return `${currencyCode} ${priceString}`;
                    }

                    return priceString;
                } catch (e) {
                    captureException(e);
                    return this.item.price;
                }
            }
        }
    }
</script>
